'use strict';

exports.__esModule = true;

function _interopRequire(obj) { return obj && obj.__esModule ? obj['default'] : obj; }

function _interopExportWildcard(obj, defaults) { var newObj = defaults({}, obj); delete newObj['default']; return newObj; }

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

var _base16 = require('base16');

_defaults(exports, _interopExportWildcard(_base16, _defaults));

var _nicinabox = require('./nicinabox');

exports.nicinabox = _interopRequire(_nicinabox);


//////////////////
// WEBPACK FOOTER
// ./~/redux-devtools-themes/lib/index.js
// module id = 3187
// module chunks = 0